<template>
  <div class="bg">
    <div class="login-box">
      <div class="base-header login-header">
        <van-icon name="cross" size="30" color="#fff" style="margin: 10px" />
        <div class="login-btn" @click="$router.push({ name: 'login' })">
          {{ $t("login.login") }}
        </div>
      </div>
      <div class="frm-login">
        <van-form @submit="onSubmit">
          <div class="item">
            <van-field
              v-model="username"
              :placeholder="$t('login.nameple')"
              @input="inputChange"
              :rules="[{ required: true }]"
            >
              <template #left-icon>
                <van-icon name="contact" color="rgb(153,153,153)" size="24" />
              </template>
            </van-field>
          </div>
          <!--
          <div class="item">
            <van-field
              v-model="phone"
              :placeholder="$t('login.phoneple')"
              @input="inputChange"
              type="digit"
              :rules="[{ required: true }]"
            >
              <template #left-icon>
                <van-icon name="phone" color="rgb(153,153,153)" size="24" />
              </template>
            </van-field>
          </div>
          -->
          <div class="item">
            <van-field
              v-model="password"
              :type="isshowpwd ? 'text' : 'password'"
              :placeholder="$t('login.pwdple')"
              @input="inputChange"
              :rules="[{ required: true }]"
            >
              <template #left-icon>
                <van-icon name="lock" color="rgb(153,153,153)" size="24" />
              </template>
              <template #right-icon>
                <van-icon
                  :name="isshowpwd ? 'eye-o' : 'closed-eye'"
                  color="rgb(153,153,153)"
                  size="24"
                  @click="isshowpwd = !isshowpwd"
                />
              </template>
            </van-field>
          </div>
          <div class="item">
            <van-field
              v-model="agepwd"
              :type="isshowpwdage ? 'text' : 'password'"
              :placeholder="$t('login.agepwdple')"
              @input="inputChange"
              :rules="[{ required: true }, { validator }]"
            >
              <template #left-icon>
                <van-icon name="lock" color="rgb(153,153,153)" size="24" />
              </template>
              <template #right-icon>
                <van-icon
                  :name="isshowpwdage ? 'eye-o' : 'closed-eye'"
                  color="rgb(153,153,153)"
                  size="24"
                  @click="isshowpwdage = !isshowpwdage"
                />
              </template>
            </van-field>
          </div>
          <div class="item">
            <van-field
              v-model="code"
              :placeholder="$t('login.codeple')"
              @input="inputChange"
              :rules="[{ required: true }]"
            >
              <template #left-icon>
                <van-icon name="medal-o" color="rgb(153,153,153)" size="24" />
              </template>
            </van-field>
          </div>
          <div style="margin: 25px 16px; color: #fff">
            <van-checkbox v-model="checked" @click="inputChange">{{
              $t("login.agree")
            }}</van-checkbox>
          </div>
          <div style="margin: 16px">
            <van-button
              native-type="submit"
              :class="istopost ? 'btn' : 'no-btn'"
              >{{ $t("login.register") }}</van-button
            >
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>

<script>
import { TokenLangKey, getTokenbyName } from "@/utils/cookies";
export default {
  name: "RegisterView",
  data() {
    return {
      username: null,
      password: null,
      agepwd: null,
      phone:null,
      code: null,
      isshowpwd: false,
      isshowpwdage: false,
      istopost: false,
      ispost: false,
      checked: false,
      lang:null
    };
  },
  mounted() {
    this.lang = getTokenbyName(TokenLangKey);
    if(!this.lang) this.lang = 'en_us'
  },
  methods: {
    validator() {
      return this.password == this.agepwd;
    },
    inputChange() {
      this.istopost =
        this.username &&
        this.username.length > 0 &&
        // this.phone &&
        // this.phone.length > 0 &&
        this.password &&
        this.password.length > 0 &&
        this.agepwd &&
        this.agepwd.length > 0 &&
        this.code &&
        this.code.length > 0 &&
        this.password == this.agepwd &&
        this.checked;
    },
    async onSubmit() {
      if (!this.istopost) return;
      if (!this.checked) return;
      await this.$http({
        method: "post",
        data: {
          username: this.username,
          password: this.password,
          phone: this.phone,
          code: this.code,
          lang: this.lang,
        },
        url: "member_register",
      }).then((res) => {
        if (res.code === 200) {
          this.$toast.success(res.msg);
          localStorage.setItem("token", res.data.id);
          this.$router.push("Mine");
        } else {
          this.$toast(res.msg);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.bg {
  background-image: linear-gradient(180deg, #f560cd, #4f2b8a);
  .login-box {
    width: 100%;
    height: 100%;
    //background: url("../../assets/img/bg-login.png") no-repeat 50% / 100%;
    background-position: 72% 50px;
    .login-header {
      .login-btn {
        float: right;
        text-align: center;
        color: #fff;
        line-height: 50px;
        top: 0px;
        margin-right: 10px;
        z-index: 999;
      }
      .lang-btn {
        float: right;
        text-align: center;
        color: #fff;
        border-radius: 10px;
        border: 1px solid #fff;
        height: 30px;
        line-height: 30px;
        padding: 0px 10px;
        margin: 10px 10px;
      }
    }
  }
  .frm-login {
    padding-top: 170px;
    .item {
      margin: 16px;
    }
  }
}
.lang-item-box {
  padding: 8px 14px;
}
</style>
<style lang="scss">
.bg {
  .frm-login {
    .item {
      .van-cell {
        background-color: rgb(255, 255, 255, 0.8) !important;
        border-radius: 8px;
        border: 1px solid #a253d0;
        line-height: 30px !important;
      }
    }
    .van-checkbox__label {
      color: #fff !important;
    }
  }
}
</style>
